import { gql } from "@apollo/client";

const ADD_TOR_COMPONENT_TABLE_C = gql`
    mutation addToRComponentTableC($torID: String!, $laID: String!, $componentCode: String!, $componentTitle: String!, $gradeReceived: String, $ects: String!, $successfullyCompleted: Boolean){
        addToRComponentTableC(torID: $torID, laID: $laID, componentCode: $componentCode, componentTitle: $componentTitle, gradeReceived: $gradeReceived, ects: $ects, successfullyCompleted: $successfullyCompleted) 
  }
`;

export default ADD_TOR_COMPONENT_TABLE_C;
